<template lang="pug">
md-content#login-form.auto-height.center-panel.md-elevation-1(md-theme="white")
    form(@submit.prevent="auth")
        md-card-header
          .md-title Авторизация
        md-card-content
            md-field
                label Логин
                md-input(v-model="login")
            md-field(v-bind:md-toggle-password="false")
                label Пароль
                md-input(v-model="password" type="password")

            .md-layout.md-gutter.md-alignment-center-right
                .md-layout-item.md-size-50
                    md-button.md-raised.md-primary(type="submit") Войти
                .md-layout-item.md-size-50
                    router-link(v-bind:to="{name: 'ResetPassword'}") Я забыл свой пароль
                    
        md-content.md-elevation-1.md-accent.message(v-if="error" md-theme="white") Ошибка авторизации.
</template>
<script>
export default {
    data() {
        return {
            login: '',
            password: '',
            error: false
        }
    },
    metaInfo() {
        return {
            title: 'Вход в систему'
        }
    },
    created() {
        this.$root.isAuth().then(user => {
            if (user && user.id) this.$router.push({ name: 'Index' });
        });
    },
    methods: {
        auth() {
            this.error = false
            this.$store.dispatch('users/login', { login: this.login.trim(), password: this.password.trim()} ).then(async user => {
                if (!user) return this.error = true;
                user = await this.$root.isAuth();
                if (!user) return this.error = true;

                if (user && user.groups && user.groups.find(item => item.code === 'storekeepers'))
                    this.$router.push({ name: 'StorekeepersFreights' });
                else {
                    this.$root.inactivityListener();
                    this.$router.push({ name: 'Index' });
                }
            });
        }
    }
}
</script>
<style lang="sass">
    #login-form
        height: auto
        width: 350px
        margin: auto
</style>


// WEBPACK FOOTER //
// Login.vue?15f9e78a